import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainRoutingModule, routerLinks } from './main-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { DeleteModalComponent } from 'src/app/modals/delete-modal/delete-modal.component';
import { StationModalComponent } from './components/stations/station-modal/station-modal.component';
import { DelayedInputDirective } from 'src/app/directives/delayed-input.directive';
import { SearchPipe } from 'src/app/pipes/search.pipe';
import { TrainModalComponent } from './components/trains/train-modal/train-modal.component';
import { IntervalModalComponent } from './components/interval-plan/interval-modal/interval-modal.component';
import { AddWeeklyScheduleComponent } from './components/weekly-schedules/add-weekly-schedule/add-weekly-schedule.component';
import { AddRouteComponent } from './components/routes/add-route/add-route.component';
import { SpecialDaysComponent } from './components/special-days/special-days.component';
import { SpecialDaysModalComponent } from './components/special-days/special-days-modal/special-days-modal.component';
import { StationTrackComponent } from './components/stations/station-track/station-track.component';
import { StationSubsequentComponent } from './components/stations/station-subsequent/station-subsequent.component';
import { PreventMultiClickDirective } from 'src/app/directives/multiClick.directive';
import { StationPremisesComponent } from './components/stations/station-premises/station-premises.component';
import { TranslationPipe } from 'src/app/pipes/translate.pipe';
import { AddPlanComponent } from './components/plans/add-plan/add-plan.component';
import { PlanDetailComponent } from './components/plans/plan-detail/plan-detail.component';
import { UserModalComponent } from './components/users/user-modal/user-modal.component';
import { UserRoleComponent } from './components/users/user-role/user-role.component';
import { UserStationComponent } from './components/users/user-station/user-station.component';
import { DuplicatePlanComponent } from './components/plans/duplicate-plan/duplicate-plan.component';
import { FormatTimeDirective } from 'src/app/directives/time-format.directive';
import { CutPlanComponent } from './components/plans/cut-plan/cut-plan.component';
import { SearchComponent } from './components/reusable-component/search/search.component';
import { DisplayModule } from './components/display-track-realization/display/display.module';
import { RealizationDetailsComponent } from './components/realization/realization-details/realization-details.component';
import { StartPostponeActionComponent } from './components/realization/start-postpone-action/start-postpone-action.component';
import { ResetCancelActionComponent } from './components/realization/reset-cancel-action/reset-cancel-action.component';
import { ActionHeaderComponent } from './components/reusable-component/action-header/action-header.component';
import { ArrivalsDeparturesComponent } from './components/realization/arrivals-departures/arrivals-departures.component';
import { ChangeTrackComponent } from './components/realization/change-track/change-track.component';
import { AddOperatorComponent } from './components/operators/add-operator/add-operator.component';
import { RouteShorteningComponent } from './components/realization/route-shortening/route-shortening.component';
import { SafePipe } from '../../pipes/safe.pipe';
import { MessagesComponent } from './components/audio-messages/messages/messages.component';
import { ActionDialogComponent } from './components/reusable-component/action-dialog/action-dialog.component';
import { TrainLocationComponent } from './components/reusable-component/train-location/train-location.component';
import { AudioControllerComponent } from './components/audio-controller/audio-controller.component';
import { AudioControllerEditComponent } from './components/audio-controller/edit/audio-controller-edit.component';
import { CacheComponent } from './components/settings/cache/cache.component';
import { DeleteCacheComponent } from './components/settings/cache/delete/delete-cache.component';
import { ParametersComponent } from './components/settings/parameters/parameters.component';
import { ActionsComponent } from './components/actions/actions.component';
import { ActionsDirective } from '../../directives/actions.directive';
import { NotificationsComponent } from './components/realization/notifications/notifications.component';
import { InfoTableMonitorComponent } from './components/info-table-monitor/info-table-monitor.component';
import { ActionHistoryComponent } from './components/realization/realization-details/action-history/action-history.component';
import { NotificationSnackBarComponent } from './components/reusable-component/notification-snack-bar/notification-snack-bar.component';
import { BroadcastMessagesComponent } from './components/broadcast-messages/broadcast-messages.component';
import { BroadcastMessageComponent } from './components/broadcast-messages/message/broadcast-message.component';
import { CancelBroadcastMessageComponent } from './components/broadcast-messages/cancel/cancel-broadcast-message.component';

@NgModule({
  declarations: [
    routerLinks,
    DeleteModalComponent,
    StationModalComponent,
    DelayedInputDirective,
    SearchPipe,
    SafePipe,
    TrainModalComponent,
    IntervalModalComponent,
    AddWeeklyScheduleComponent,
    AddRouteComponent,
    SpecialDaysComponent,
    SpecialDaysModalComponent,
    StationTrackComponent,
    StationSubsequentComponent,
    PreventMultiClickDirective,
    StationPremisesComponent,
    TranslationPipe,
    AddPlanComponent,
    PlanDetailComponent,
    UserModalComponent,
    UserRoleComponent,
    UserStationComponent,
    DuplicatePlanComponent,
    FormatTimeDirective,
    CutPlanComponent,
    SearchComponent,
    RealizationDetailsComponent,
    StartPostponeActionComponent,
    ResetCancelActionComponent,
    ActionHeaderComponent,
    ArrivalsDeparturesComponent,
    ChangeTrackComponent,
    AddOperatorComponent,
    RouteShorteningComponent,
    MessagesComponent,
    ActionDialogComponent,
    TrainLocationComponent,
    AudioControllerComponent,
    AudioControllerEditComponent,
    CacheComponent,
    DeleteCacheComponent,
    ParametersComponent,
    ActionsDirective,
    ActionsComponent,
    NotificationsComponent,
    InfoTableMonitorComponent,
    ActionHistoryComponent,
    NotificationSnackBarComponent,
    BroadcastMessagesComponent,
    BroadcastMessageComponent,
    CancelBroadcastMessageComponent,
  ],
  imports: [CommonModule, MainRoutingModule, FormsModule, ReactiveFormsModule, MaterialModule, DisplayModule],
  exports: [TranslationPipe, DisplayModule],
})
export class MainModule {}
